export default function ReturnButton({ history }) {

  function GoBack() {
    history.goBack();
  }

  return (
    <button onClick={GoBack} className="btn btn-secondary return-button">Voltar</button>
  )
}